export default function ContactSection() {
  return (
    <section id="contact" className="py-16 sm:py-20 md:py-24 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-8 sm:gap-10 md:gap-12 items-center">
          <div>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
              Get in Touch
            </h2>
            <p className="text-base sm:text-lg text-gray-700 mb-6 sm:mb-8 leading-relaxed">
              Have questions about the event, registration, or payment? We're here to help! Reach out to our team and we'll get back to you as soon as possible.
            </p>

            <div className="space-y-5 sm:space-y-6">
              <div className="flex items-start">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-emerald-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-emerald-600 text-lg sm:text-xl"></i>
                </div>
                <div className="ml-3 sm:ml-4">
                  <h3 className="text-base sm:text-lg font-semibold text-gray-900 mb-1">Email Us</h3>
                  <a href="mailto:Info@bucketlistgolf.org" className="text-sm sm:text-base text-emerald-600 hover:text-emerald-700 cursor-pointer break-all">
                    Info@bucketlistgolf.org
                  </a>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-emerald-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-emerald-600 text-lg sm:text-xl"></i>
                </div>
                <div className="ml-3 sm:ml-4">
                  <h3 className="text-base sm:text-lg font-semibold text-gray-900 mb-1">Call Us</h3>
                  <a href="tel:+14132227701" className="text-sm sm:text-base text-emerald-600 hover:text-emerald-700 cursor-pointer">
                    (413) 222-7701
                  </a>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-emerald-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-emerald-600 text-lg sm:text-xl"></i>
                </div>
                <div className="ml-3 sm:ml-4">
                  <h3 className="text-base sm:text-lg font-semibold text-gray-900 mb-1">Event Location</h3>
                  <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                    Alaqua Country Club<br />
                    Longwood, Florida
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-emerald-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-line text-emerald-600 text-lg sm:text-xl"></i>
                </div>
                <div className="ml-3 sm:ml-4">
                  <h3 className="text-base sm:text-lg font-semibold text-gray-900 mb-1">Support Hours</h3>
                  <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                    Monday - Friday: 9:00 AM - 6:00 PM EST<br />
                    Saturday - Sunday: 10:00 AM - 4:00 PM EST
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="relative h-64 sm:h-80 md:h-96 rounded-lg overflow-hidden shadow-2xl">
            <img
              src="https://static.readdy.ai/image/57c982531ce74d8992a8785896e0bafd/8e0dcbce1d6ba65449b413552b43a9d0.jpeg"
              alt="Alaqua Country Club Landscape"
              className="w-full h-full object-cover object-center"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
